import Link from 'next/link';
import styled from 'styled-components';
import { colors } from 'constants/theme';
import MEDIA from 'helpers/mediaTemplates';
import BaseImage from 'components/image/baseImage.jsx';
export const Container = styled.div.withConfig({
  displayName: "recommendationscss__Container",
  componentId: "sc-wv02v1-0"
})(["margin-top:7rem;padding-top:4rem;border-top:1px solid ", ";"], colors.lightGrey);
export const SLink = styled(Link).withConfig({
  displayName: "recommendationscss__SLink",
  componentId: "sc-wv02v1-1"
})(["color:", ";text-decoration:none;h3{color:", ";margin-bottom:1rem;}p{margin-top:0.5rem;span{color:", ";}}"], colors.darkGrey, colors.black, colors.secondary);
export const Card = styled.div.withConfig({
  displayName: "recommendationscss__Card",
  componentId: "sc-wv02v1-2"
})(["min-height:17.3rem;margin:5px;padding:0 1rem;border:1px solid ", ";color:", ";text-decoration:none;display:flex;gap:16px;align-items:flex-start;", ";"], colors.lightGrey, colors.grey, MEDIA.PHONE`
    gap: 0px;
    flex-direction: column;
  `);
export const ThumbWrapper = styled.div.withConfig({
  displayName: "recommendationscss__ThumbWrapper",
  componentId: "sc-wv02v1-3"
})(["flex:0 0 30%;margin:2rem 0rem 0.5rem 0rem;position:relative;", ";"], MEDIA.PHONE`
    width: 100%;
    margin: 1rem 0rem 0rem 0rem;
  `);
export const Thumb = styled(BaseImage).withConfig({
  displayName: "recommendationscss__Thumb",
  componentId: "sc-wv02v1-4"
})(["box-shadow:-1px 3px 6px 1px rgba(0,0,0,0.3);position:relative !important;width:100%;"]);
export const Details = styled.div.withConfig({
  displayName: "recommendationscss__Details",
  componentId: "sc-wv02v1-5"
})(["flex:1;"]);